export default __webpack_public_path__ + "static/media/twitter.a2567d3b.svg";